import { UploadedFile } from '@paragon/component-processor';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { updateQuantities } from '../data/convertCompareCount';
import { prepareFileDataForUpload } from './files';
import { AsyncThunkActionVoid } from './thunkActions';

export const updateTreQuantities =
  (fileData: readonly UploadedFile[]): AsyncThunkActionVoid =>
  async (dispatch) => {
    const spinnerId = dispatch(addSpinnerMessage('Updating file quantities...'));

    try {
      const transformedFileData = await prepareFileDataForUpload(fileData);

      const updatedResults = await updateQuantities(transformedFileData);
      updatedResults.downloadWithName('UpdatedQuantities.zip');
    } catch {
      alert('Error updating quantities.');
    } finally {
      dispatch(removeSpinnerMessage(spinnerId));
    }
  };
